// extracted by mini-css-extract-plugin
export default {"resetButtoncss":"userinfo_resetButtoncss__OmvwP","sticky":"userinfo_sticky__0iUvx","table-container":"userinfo_table-container__A5jR7","tableListing":"userinfo_tableListing__xL7G1"};